import type { CampaignRejectReason } from '@epasu/core';

/**
 * Beschriftung der Abweisungsgründe aus `campaigns.addMembers` und
 * `campaigns.addFromSourceList` — an zwei Stellen gebraucht (Mitglieder-
 * Reiter der Kampagne, „Nächsten Ansprechpartner aufnehmen“ auf der
 * Firmenakte), deshalb hier statt doppelt.
 */
export const CAMPAIGN_REJECT_LABEL: Record<CampaignRejectReason, string> = {
  gesperrt: 'ist gesperrt',
  abgemeldet: 'hat sich abgemeldet',
  schon_drin: 'ist schon Mitglied',
  fremde_zielgruppe: 'gehört zu einer anderen Zielgruppe',
  laufendes_gespraech: 'hat schon ein laufendes Gespräch in dieser Kampagne',
  nicht_gefunden: 'wurde nicht gefunden',
};
